import { render, staticRenderFns } from "./TitleRankingList.vue?vue&type=template&id=883bd03a&scoped=true"
import script from "./TitleRankingList.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleRankingList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleRankingList.vue?vue&type=style&index=0&id=883bd03a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883bd03a",
  null
  
)

export default component.exports